<template>
  <div class="send-blessing-page">
    <!-- 顶部装饰 -->
    <div class="top-decoration">
      <div class="decoration-circle circle-1"></div>
      <div class="decoration-circle circle-2"></div>
      <div class="decoration-circle circle-3"></div>
    </div>

    <!-- 顶部导航 -->
    <div class="header">
      <h1 class="page-title">{{ pageTitle }}</h1>
    </div>

    <!-- 头像区域 -->
    <div class="avatar-section">
      <div class="avatar-container">
        <div class="avatar-circle">
          <div class="avatar-placeholder">
            <img 
              v-if="formData.blessType === 'BIRTHDAY'" 
              src="@/assets/medal/quaquaka/birthdayHeader.png" 
              alt="生日头像"
              class="avatar-image"
            >
            <img 
              v-else-if="formData.blessType === 'ANNIVERSARY'" 
              src="@/assets/medal/quaquaka/anniversaryHead.png" 
              alt="周年头像"
              class="avatar-image"
            >
          </div>
        </div>
        <div class="avatar-ring"></div>
      </div>
      <div class="birthday-info">
        <p class="date-text">{{ eventText }}</p>
        <p class="prompt-text">写下您对TA的祝福</p>
      </div>
    </div>

    <!-- 祝福语输入区域 -->
    <div class="blessing-section">
      <label class="blessing-label">祝福语：</label>
      <textarea
        class="blessing-textarea"
        v-model="formData.content"
        placeholder="请输入您的祝福..."
        maxlength="200"
      ></textarea>
      
      <!-- 快捷祝福语 -->
      <div class="quick-blessing">
        <span class="quick-label">快捷祝福：</span>
        <div class="quick-tags">
          <span
            v-for="(tag, idx) in quickTags"
            :key="idx"
            class="quick-tag"
            :class="{ active: formData.content === tag }"
            @click="useQuickTag(tag)"
          >
            {{ tag }}
          </span>
        </div>
      </div>
      
      <!-- 操作区域 -->
      <div class="action-bar">
        <span class="word-count">{{ formData.content.length }}/200</span>
        <button class="submit-btn" @click="submitBlessing" :disabled="!canSubmit">
          <span class="btn-text">提交</span>
          <span class="btn-icon">✈</span>
        </button>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div class="toast" :class="{ show: toastShow }">
      <span class="toast-icon">✓</span>
      {{ toastMessage }}
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import { getToken } from "@/utils/cookie";
import apiLogin from "@/apis";

export default {
  name: "SendBlessingPage",
  data() {
    return {
      formData: {
        blessType: "BIRTHDAY",
        receiverName: "",
        content: "",
      },
      // 不同类型的快捷祝福语
      quickTagsMap: {
        // 生日祝福
        BIRTHDAY: [
          "生日快乐，天天开心！",
          "愿你所求皆如愿！",
          "新的一岁，越来越好！",
          "心想事成，万事如意！",
          "岁岁平安，年年如意！",
          "前程似锦，一帆风顺！",
        ],
        // 

        // 周年祝福
        ANNIVERSARY: [
          "风雨同舟，感谢有你！",
          "周年快乐，继续加油！",
          "携手同行，共创辉煌！",
          "感恩相伴，一路有你！",
          "愿未来更加精彩！",
          "共同成长，见证辉煌！",
        ],
      },
      toastShow: false,
      toastMessage: "",
      userName: "",
      blessType: "",
      evenEmpNo: "",
      evenEmpOrgId: "",
      evenDate: "",
      empno: "",
      userInfo: {},
    };
  },
  computed: {
    canSubmit() {
      return this.formData.receiverName.trim() && this.formData.content.trim();
    },
    // 当前类型的快捷祝福语
    quickTags() {
      return this.quickTagsMap[this.formData.blessType] || this.quickTagsMap.BIRTHDAY;
    },
    // 页面标题
    pageTitle() {
      const name = this.formData.receiverName || '寿星';
      switch (this.formData.blessType) {

        case 'ANNIVERSARY':
          return `祝${name}周年快乐`;
        default:
          return `祝${name}生日快乐`;
      }
    },
    // 事件描述文本
    eventText() {
      const name = this.formData.receiverName || '同事';
      const date = this.formatDate(this.evenDate);
      switch (this.formData.blessType) {

        case 'ANNIVERSARY':
          return `${date}是${name}入职周年纪念日`;
        default:
          return `${date}是${name}生日`;
      }
    },
  },
  mounted() {
    let token = window.sessionStorage.hrToken;
    let hrToken = getToken();
    if (token) {
      this.empno = hrToken;
      this.initData();
    } else {
      this.$bus.$on("processToken", (res) => {
        this.empno = res;
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.initData();
        });
      });
    }
  },
  methods: {
    getHrToken(username) {
      return new Promise((resolve) => {
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            localStorage.setItem("userInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          resolve();
        }
      });
    },

    initData() {
      // type类型: BIRTHDAY("BIRTHDAY", "生日祝福"), ANNIVERSARY("ANNIVERSARY", "周年祝福")
      const { evenEmp, type, evenEmpNo, evenEmpOrgId, evenDate } =
        this.$route?.query || {};
      this.userName = evenEmp || "";
      this.blessType = type || "BIRTHDAY";
      this.evenEmpNo = evenEmpNo || "";
      this.evenEmpOrgId = evenEmpOrgId || "";
      this.evenDate = evenDate || "";

      if (this.userName) {
        this.formData.receiverName = this.userName;
      }
      if (this.blessType) {
        this.formData.blessType = this.blessType;
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },

    goBack() {
      this.$router.back();
    },

    useQuickTag(tag) {
      this.formData.content = tag;
    },

    resetForm() {
      this.formData.content = "";
    },

    async submitBlessing() {
      if (!this.canSubmit) {
        this.showToast("请填写完整信息");
        return;
      }
      this.userInfo = JSON.parse(localStorage.getItem("store")).userInfo;

      const params = {
        blessingType: this.formData.blessType,
        blessingYear: new Date().getFullYear().toString(),
        eventDate: this.evenDate,
        receiverNo: this.evenEmpNo,
        receiverName: this.formData.receiverName,
        receiverOrg: this.evenEmpOrgId,
        senderNo: getToken() || "",
        senderName: this.userInfo.nickname || "",
        senderOrg: this.userInfo.userDepartmentId || "",
        content: this.formData.content,
      };

      try {
        const res = await api.sendBlessingComment(params);
        console.log("发送祝福成功", res);
        this.showToast("祝福已发送！");
        this.resetForm();
      } catch (err) {
        console.error("发送祝福失败", err);
        this.showToast("发送失败，请重试");
      }
    },

    showToast(message) {
      this.toastMessage = message;
      this.toastShow = true;
      setTimeout(() => {
        this.toastShow = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
$primary-color: #60c985;       // 主绿色
$primary-light: #e6f7ee;       // 浅绿背景
$success-color: #81d4ab;       // 清新浅绿
$text-primary: #333;
$text-secondary: #666;
$text-hint: #999;
$border-color: #e5e7eb;
$bg-gradient-start: #e6f7ee;   // 背景渐变：浅绿
$bg-gradient-end: #ffffff;     // 背景渐变：白

@media screen and (max-width: 600px) {
  .send-blessing-page {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .send-blessing-page {
    width: 276px * $zoom;
  }
}

.send-blessing-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: linear-gradient(180deg, $bg-gradient-start 0%, $bg-gradient-end 60%);
}

/* 顶部装饰 */
.top-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  pointer-events: none;

  .decoration-circle {
    position: absolute;
    border-radius: 50%;
    opacity: 0.3;
    animation: float 6s ease-in-out infinite;
  }

  .circle-1 {
    width: 80px;
    height: 80px;
    background: $primary-color;
    top: 60px;
    left: -40px;
    animation-delay: 0s;
  }

  .circle-2 {
    width: 60px;
    height: 60px;
    background: $success-color;
    top: 100px;
    right: -30px;
    animation-delay: 2s;
  }

  .circle-3 {
    width: 40px;
    height: 40px;
    background: #ffd966;
    top: 150px;
    left: 50%;
    animation-delay: 4s;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-20px) scale(1.1);
    opacity: 0.5;
  }
}

/* 头部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: transparent;
  position: relative;
  z-index: 10;

  .page-title {
    font-size: 28px;
    font-weight: 600;
    color: $text-primary;
    margin: 0;
    text-align: center;
  }


}

/* 头像区域 */
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  position: relative;
  z-index: 10;

  .avatar-container {
    position: relative;
    margin-bottom: 30px;
  }

  .avatar-circle {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: linear-gradient(135deg, $primary-color, $success-color);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 32px rgba($primary-color, 0.3);
    position: relative;
    z-index: 2;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.05);
    }
  }

  .avatar-ring {
    position: absolute;
    top: -8px;
    left: -8px;
    right: -8px;
    bottom: -8px;
    border-radius: 50%;
    border: 3px solid rgba($primary-color, 0.2);
    animation: ring-pulse 2s ease-in-out infinite;
  }

  .avatar-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .avatar-image {
    width: 120px;
    height: 120px;
    object-fit: contain;
  }

  .avatar-label {
    font-size: 60px;
    font-weight: 700;
    color: #fff;
  }

  .birthday-info {
    text-align: center;
  }

  .date-text {
    font-size: 28px;
    color: $text-secondary;
    margin: 0 0 10px;
    font-weight: 500;
  }

  .prompt-text {
    font-size: 26px;
    color: $text-hint;
    margin: 0;
  }
}

@keyframes ring-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

/* 祝福语输入区域 */
.blessing-section {
  padding: 0 20px 30px;
  position: relative;
  z-index: 10;

  .blessing-label {
    display: block;
    font-size: 28px;
    color: $text-primary;
    margin-bottom: 16px;
    font-weight: 600;
  }

  .blessing-textarea {
    width: 100%;
    height: 250px;
    padding: 20px;
    font-size: 28px;
    border: 2px solid $border-color;
    border-radius: 20px;
    outline: none;
    resize: none;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.9);
    font-family: inherit;
    transition: all 0.3s;
    backdrop-filter: blur(10px);

    &::placeholder {
      color: $text-hint;
    }

    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 4px rgba($primary-color, 0.1);
      background: #fff;
    }
  }

  /* 快捷祝福语 */
  .quick-blessing {
    margin-top: 20px;

    .quick-label {
      font-size: 26px;
      color: $text-secondary;
      margin-bottom: 14px;
      display: block;
    }

    .quick-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }

    .quick-tag {
      font-size: 24px;
      padding: 12px 20px;
      background: rgba(255, 255, 255, 0.8);
      color: $text-secondary;
      border-radius: 25px;
      cursor: pointer;
      transition: all 0.3s;
      border: 1px solid $border-color;
      backdrop-filter: blur(10px);

      &:hover {
        background: $primary-light;
        border-color: $primary-color;
        color: $primary-color;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba($primary-color, 0.15);
      }

      &.active {
        background: $primary-color;
        border-color: $primary-color;
        color: #fff;
      }
    }
  }

  /* 操作区域 */
  .action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 28px;

    .word-count {
      font-size: 24px;
      color: $text-hint;
    }

    .submit-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 16px 40px;
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      background: linear-gradient(135deg, $primary-color, $success-color);
      border: none;
      border-radius: 30px;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 6px 20px rgba($primary-color, 0.3);

      &:disabled {
        background: #bdd7f5;
        cursor: not-allowed;
        box-shadow: none;
      }

      &:not(:disabled):hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 28px rgba($primary-color, 0.4);
      }

      &:not(:disabled):active {
        transform: translateY(-1px);
      }

      .btn-icon {
        font-size: 24px;
      }
    }
  }
}

/* 提示弹窗 */
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 24px 48px;
  border-radius: 20px;
  font-size: 28px;
  opacity: 0;
  transition: all 0.3s;
  z-index: 1000;
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: 12px;

  .toast-icon {
    font-size: 32px;
    color: $success-color;
    animation: check-bounce 0.5s ease;
  }

  &.show {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes check-bounce {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>